import { render, staticRenderFns } from "./HashTagCard.vue?vue&type=template&id=8c5c3476&scoped=true"
import script from "./HashTagCard.vue?vue&type=script&lang=js"
export * from "./HashTagCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c3476",
  null
  
)

export default component.exports